module.exports = "/fonts/NeoSansStd-Regular.svg?78cde219157a04ff3e9fe0fc4a9978bb";